<template>
    <div class="pt-6">
        <input-radio-boolean
            class="flex items-center"
            label="Send notifications for new deals?"
            :name="name"
            :value="value"
            true="Yes"
            false="No"
        />
    </div>
</template>

<script>
export default {
    props: {
        name: {},
        value: {},
    },
}
</script>
